import { render } from "./FormCarousel.vue?vue&type=template&id=45712b59"
import script from "./FormCarousel.vue?vue&type=script&lang=js"
export * from "./FormCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__